import axiosInstance from './axiosInstance';

export interface ChatSession {
  id: number;
  title: string;
  created_at: string;
  updated_at: string;
}

export interface Message {
  id: string;
  chat_session?: string; // Make optional as it might not be present in all contexts
  sender: 'user' | 'bot';
  content: string;
  timestamp: string;
  type?: 'message' | 'image'; // Optional because backend defaults to plain text
  url?: string; // Added url property for image messages
  alt_text?: string; // Added alt_text property for image messages
}

interface SuggestedQuestion {
  id: string;
  text: string;
  category?: string;
  order?: number;
}

export const getChatSessions = async (): Promise<ChatSession[]> => {
  const response = await axiosInstance.get<ChatSession[]>('/chat/sessions/');
  return response.data;
};

export const getChatSessionMessages = async (sessionId: number): Promise<Message[]> => {
  const response = await axiosInstance.get<Message[]>(`/chat/sessions/${sessionId}/messages/`);
  return response.data;
};

export const createNewChatSession = async (): Promise<ChatSession> => {
  const response = await axiosInstance.post<ChatSession>('/chat/sessions/');
  return response.data;
};

export const sendMessage = async (sessionId: number, chatInput: string): Promise<any> => {
  const response = await axiosInstance.post('/chat/send/', { sessionId, chatInput });
  return response.data;
};

export const getSuggestedQuestions = async (): Promise<SuggestedQuestion[]> => {
  const response = await axiosInstance.get<SuggestedQuestion[]>('/chat/suggested-questions/');
  return response.data;
};

export const deleteChatSession = async (sessionId: number): Promise<void> => {
  await axiosInstance.delete(`/chat/sessions/${sessionId}/`);
};

export const updateChatSession = async (sessionId: number, title: string): Promise<ChatSession> => {
  const response = await axiosInstance.patch<ChatSession>(`/chat/sessions/${sessionId}/`, {
    title,
  });
  return response.data;
};
